import { SvgIcon } from '@mui/material';
import { Box } from '@mui/material';


export default function LineDraw (props) {

  return (
    <Box className={`${props?.className ? props.className : ''}`} sx={ props?.sx ? props.sx : {}}>
      <SvgIcon
        sx={{
          width: '100%',
          height: '100%'
        }}
        width="503"
        height="715"
        viewBox="0 0 503 715"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M20 338.254L154.791 406.464L389.398 524.838L0.58252 715H155.357L465 563.56V486.818L88 296.599V226.147L502.598 0H360.593L88 148.689V0H20V338.254Z" fill="url(#paint0_linear_1480_8749)"/>
        <defs>
        <linearGradient id="paint0_linear_1480_8749" x1="251.59" y1="0" x2="251.59" y2="715" gradientUnits="userSpaceOnUse">
        <stop stopColor="white" stopOpacity="0"/>
        <stop offset="0.265625" stopColor="white"/>
        <stop offset="0.760417" stopColor="white"/>
        <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        </defs>
      </SvgIcon>
    </Box>
  );
}
